import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const getall = "/marcom/template/getAll";

export default {
  getAll(payload) {
    return Repository.post(`${getall}`, payload);
  },
};
